module.exports = require("next/dist/server/web/sandbox");